import {
  ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_COMPONENT,
} from '../../constants/actions';

const defaultState = {
  components: [],
  singleComponent: undefined,
  didLoadComponents: false,
  isLoadingComponents: false,
  isLoadingSingleComponent: false,
  isAddingComponent: false,
  isDeletingComponent: false,
  isComponentDeleted: false,
  selectedComponent: undefined,
  filters: {
    dynasties: [],
    cities: [],
    tags: [],
  },
};

const componentsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION:
      return {
        ...state,
        components: [],
        isLoadingComponents: true,
        didLoadComponents: false,
      };
    case ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION:
      return {
        ...state,
        components: action.payload,
        isLoadingComponents: false,
        didLoadComponents: true,
      };
    case ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION:
      return {
        ...state,
        isAddingComponent: true,
      };
    case ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION: {
      const newComponentsList = state.components.push(action.payload);
      return {
        ...state,
        isAddingComponent: false,
        components: newComponentsList,
      };
    }
    case ACT_INSTANCES_GET_COMPONENT_INIT_ACTION:
      return {
        ...state,
        singleComponent: undefined,
        isLoadingComponents: true,
      };
    case ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION:
      return {
        ...state,
        singleComponent: action.payload,
        isLoadingSingleComponent: false,
      };
    case ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION:
      return {
        ...state,
        isDeletingComponent: true,
        isComponentDeleted: false,
      };
    case ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION:
      return {
        ...state,
        isDeletingComponent: false,
        isComponentDeleted: true,
      };
    case ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_COMPONENT:
      return {
        ...state,
        selectedComponent: action.payload,
        singleComponent: action.payload,
      };
    default:
      return state;
  }
};

export default componentsReducer;
